<script lang="ts">
  export let left: number;
  export let targetTop: number;
  export let targetBottom: number;
  export let targetWidth: number;
  export let height: number;
</script>

<div>
  <!-- The upper pier -->
  <!--
    Note: we use png instead of svg because
    the svg's viewbox prevents stretching to
    fill the img size.
   -->
  <img
    class="topObstacle"
    src="/assets/pitchy-fish/pier.png"
    alt="Pier from below water"
    style="
      left: {left}px;
      top: {targetTop - height}px;
      width: {targetWidth}px;
      height: {height}px;
      object-fit: fill;
      "
  />

  <!-- The lower pier -->
  <img
    class="obstacle"
    src="/assets/pitchy-fish/pier.png"
    alt="Pier from above water"
    style="
      left: {left}px;
      top: {targetBottom}px;
      width: {targetWidth}px;
      height: {height}px;
      object-fit: fill;
      "
  />
</div>

<style>
  /** obstacles should generate in game container. */
  .obstacle {
    position: absolute;
    z-index: 4;
  }

  .topObstacle {
    transform: rotate(180deg);
    position: absolute;
    z-index: 4;
  }
</style>
